export type I18NAction = { type: 'SWITCH_LOCALE'; locale: string };

export function switchLocale(locale: string): I18NAction {
  return { type: 'SWITCH_LOCALE', locale };
}
